import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LONG_RUNNING_PROCESS_CONTROL_HELP: HelpContent[] = [
    {
        helpContentId: 'long-running-process-control.message',
        tooltipText: 'Send a control message to a service host'
    }
];
